export default __webpack_public_path__ + "static/media/profileIConNEw.0557a87b.svg";